import type {RouteRecordRaw} from 'vue-router';

export const addressRoutes: RouteRecordRaw[] = [
  {
    path: '/addresses',
    meta: {
      permissions: ['selectAddress'],
      title: (t) => t('location.addressBook.addressBook'),
    },
    children: [
      {
        name: 'addresses',
        path: '',
        component: () => import('@/views/AddressBook/AddressBookOverview.vue'),
        meta: {
          title: (t) => t('location.addressBook.addressBook'),
        },
      },
      {
        name: 'addresses-edit',
        path: ':id',
        props: true,
        component: () => import('@/views/AddressBook/Edit/AddressBookEdit.vue'),
        meta: {
          title: (t) => t('location.addressBook.edit'),
        },
      },
      {
        name: 'addresses-create',
        path: 'create',
        component: () => import('@/views/AddressBook/Create/AddressBookCreate.vue'),
        meta: {
          title: (t) => t('location.addressBook.create'),
        },
      },
      {
        name: 'addresses-create-multiple',
        path: 'import',
        component: () => import('@/views/AddressBook/Import/AddressBookImport.vue'),
        meta: {
          feature: 'page.addresses.import',
          title: (t) => t('location.addressBook.import'),
        },
      },
    ],
  },
];
